import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, Users, Star, Wrench, ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';

const UstaJoinSection = () => {
  const navigate = useNavigate();

  return (
    <section className="py-10 md:py-16 bg-white overflow-hidden">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12">
          {/* Sol - Görsel */}
          <div className="w-full md:w-1/2 relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src="https://static.prod-images.emergentagent.com/jobs/84fc7f27-88da-4cbc-8349-efcf97b1d474/images/29adb0bd8b051a2651c875a1d0e491d8259e7589df2c890584b61ec05b532f51.png" 
                alt="Usta olarak katıl" 
                className="w-full h-auto"
                loading="lazy"
                decoding="async"
              />
              <div className="absolute bottom-4 left-4 bg-white/95 backdrop-blur-sm rounded-xl px-4 py-3 shadow-lg">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-gradient-to-br from-[#E29578] to-[#D67A56] rounded-full flex items-center justify-center">
                    <Wrench className="w-5 h-5 text-white" />
                  </div>
                  <div>
                    <p className="text-gray-900 font-bold text-sm">500+ Aktif Usta</p>
                    <p className="text-gray-500 text-xs">Türkiye genelinde</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Sağ - İçerik */}
          <div className="w-full md:w-1/2">
            <div className="inline-flex items-center gap-2 bg-[#E29578]/10 rounded-full px-4 py-1.5 mb-4">
              <Wrench className="w-4 h-4 text-[#E29578]" />
              <span className="text-[#E29578] text-sm font-semibold">Usta Ol, Kazan</span>
            </div>
            
            <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-4 leading-tight">
              Uzmanlığını Değerlendir,<br />
              <span className="text-[#006D77]">Gelirini Artır</span>
            </h2>
            
            <p className="text-gray-600 mb-6 leading-relaxed">
              HizmetGeliyo ailesiyle binlerce müşteriye ulaş. Kendi çalışma saatlerini belirle, 
              işlerini yönet ve kazancını artır. Komisyon sadece iş tamamlandığında!
            </p>

            <div className="space-y-3 mb-6">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <CheckCircle className="w-4 h-4 text-green-600" />
                </div>
                <span className="text-gray-700 text-sm">Ücretsiz üyelik, iş alırken ücret ödeme</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <Users className="w-4 h-4 text-blue-600" />
                </div>
                <span className="text-gray-700 text-sm">Binlerce potansiyel müşteriye erişim</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <Star className="w-4 h-4 text-purple-600" />
                </div>
                <span className="text-gray-700 text-sm">Esnek çalışma, kendi programını yap</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <Button
                onClick={() => navigate('/usta-kayit')}
                className="bg-[#E29578] hover:bg-[#D67A56] text-white px-6 py-3 rounded-full font-semibold shadow-lg hover:shadow-xl transition-all"
              >
                Hemen Başvur
                <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
              <Button
                onClick={() => navigate('/neden-bize-katil')}
                variant="outline"
                className="border-2 border-[#006D77] text-[#006D77] hover:bg-[#006D77] hover:text-white px-6 py-3 rounded-full font-semibold transition-all"
              >
                Neden Bize Katılmalısın?
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UstaJoinSection;
